import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// 嗅探器
import LanguageDetector from 'i18next-browser-languagedetector';
// 自編語言包
import Languages from './languages';
// antd語言包
import antdEnUS from 'antd/lib/locale/en_US';
import entdZhCN from 'antd/lib/locale/zh_CN';
import entdZhHK from 'antd/lib/locale/zh_HK';
// moment語言包
import moment from 'moment';
import 'moment/locale/zh-cn';
import 'moment/locale/zh-hk';

import HTTPApi from '@services';
const { setUserLanguage } = HTTPApi.user;



const { _zhCN, _zhHK, _enUS } = Languages;
const LanguagesEnum = Object.freeze({
    'en': 'English',
    'zh-HK': '繁體中文',
    'zh-CN': '简体中文',
});// 枚舉，用於切換語言
const resources = {};
const antdResources = {};
const supportRegion = new Set(); // 所有支持的地區集合
/**
 * @description:  根據地區生成語言包，當前支持簡中/繁中/英文，
 * @parameter {*}
 * @author: Mingzhen
 * @return {Void}
 */
const setResources = (() => {
    // 每個語言包所用於的地區
    // 注意，other為非支持語言，不在語言範圍內統一使用英文，可根據需求修改
    const trans = new Map([
        [['zh', 'zh-CN'], { self: _zhCN, antd: entdZhCN, moment: 'zh-cn' },], // 简中
        [['zh-HK', 'zh-TW', 'Macao', 'zh-MO'], { self: _zhHK, antd: entdZhHK, moment: 'zh-hk' },], // 繁中
        [['en'], { self: _enUS, antd: antdEnUS, moment: 'en' },], // English
    ]);
    for (const [lngNames, lngData,] of trans) {
        lngNames.forEach(lngName => {
            resources[lngName] = { translation: lngData.self, moment: lngData.moment };
            antdResources[lngName] = lngData.antd;
            supportRegion.add(lngName)
        })
    }
})();


i18n
    .use(LanguageDetector) // 嗅探當前環境語言
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        }
    }, (err) => {
        // 錯誤
        if (err) throw err;
        i18n.LanguagesEnum = LanguagesEnum;
        /**
         * @description: 新增設置語言函數，為了設置時同時設置antd和moment的語言
         * @parameter {*}
         * @author: Mingzhen
         * @return {*}
         * @param {*} value
         */
        i18n.setLocalLanguage = function (value, sendToDB) {
            if (!supportRegion.has(value)) value = 'en'; // 不支持所在地區時使用English
            // 設置moment的語言
            // const isZh = value.startsWith('zh');
            moment.locale(resources[value].moment, {
                longDateFormat: {
                    LLL: 'YYYY-M-DD HH:mm',
                }
            });
            // 設置項目文本的語言
            this.changeLanguage(value);
            // 設置antd組件的語言
            
            this.antdLocal = antdResources[value] || antdEnUS;
            // sendToDB 是否发送到数据库
            if (sendToDB) {
                const lngEnum = {
                    'en': 1,
                    'zh-CN': 2,
                    'zh-HK': 3,
                }
                setUserLanguage({
                    language: lngEnum[value]
                })
            }
        }
        // 初始化
        i18n.setLocalLanguage(i18n.language);
    });


export default i18n;
